import type { Pattern } from "../types.js";

/**
 * REAL CONTENT — Enneatype 9. Replaces FAKE_PATTERN_9.
 *
 * Source: `docs/canonical/Especificacion_canonica_v1.1_y_plantilla_maestra.docx`,
 * section 12 «Eneatipo 9 — aplicación provisional», Bloque A. Same master
 * template as pattern 1, built from Vilaseca (chapter "Eneatipo 9") and the
 * project blog, every field carrying its provenance tag.
 *
 * English for the same reason as pattern 1, with the Spanish original kept
 * beside each field so the translation stays reviewable.
 *
 * `confusablePatterns` lists only what exists in the alpha. The canonical list
 * is wider — types 2 (puts others' needs first), 6 (doubts and postpones
 * decisions) and 5 (withdraws or disconnects in conflict) — written down here
 * for the increment that widens past 1 and 9.
 */
export const PATTERN_9: Pattern = {
  id: "9",
  number: 9,
  // «el mediador» — Vilaseca usa "el indolente"; el blog, "the Mediator".
  workingName: "The mediator (working name)",
  // «Patrón organizado alrededor de fusionarse con los deseos de otros y evitar
  //  el conflicto, perdiendo de vista la propia prioridad»
  shortHypothesis:
    "A pattern organised around merging with what other people want and " +
    "avoiding conflict, until your own priority drops out of view.",
  // «Dificultad para decidir, tendencia a posponer, desconexión de las propias
  //  necesidades, pasividad ante el conflicto»
  whatItExplains:
    "Difficulty deciding, a tendency to postpone, disconnection from your " +
    "own needs, and going passive when conflict appears.",
  // «La pereza como rasgo moral; por qué una persona concreta prioriza la
  //  armonía sobre otros valores (puede tener otros orígenes)»
  whatItDoesNotExplain:
    "Laziness as a moral trait, or why one particular person puts harmony " +
    "above other values — that can come from somewhere else entirely.",
  // «Que la persona se defina como "la tranquila/pasiva de siempre" y use la
  //  etiqueta para justificar la evitación en vez de observarla»
  identityRisk:
    "That you settle into “I'm the calm one, I always have been” and use " +
    "the label to justify the avoidance instead of watching it.",
  // Corregido el 16 ago, mismo motivo que en el patrón 1: el canon lista 2, 5
  // y 6 para el 9, nunca el 1. De esos tres, el 6 es el que existe en el alfa.
  confusablePatterns: ["6"],
  sourceRefs: [
    "Especificacion_canonica_v1.1_y_plantilla_maestra.docx §12, Bloque A",
    "Vilaseca, chapter “Eneatipo 9” — [FUENTE PROYECTO]",
    "Project blog, “the Mediator”",
    "Working name and short formulation are [PROPUESTA], not established fact"
  ],
  contentVersion: "canon-1.1"
};
